<script setup>
// RemoveButtonは状態を知らない。あくまでイベントを渡すだけ。

const objectOfAttrs = {
    'data-id': 'remove-button',
    type: 'button'
}
defineProps({
    label: {
        type: String,
        default: '削除'
    }
});
//クリックイベントを親に通知する
const emit = defineEmits(['click']);
</script>

<template>
    <button v-bind="objectOfAttrs" @click="emit('click')" class="cursor-pointer h-8 w-8 rounded border-2
    mx-auto col-span-1  bg-red-600 border-red-600 text-white font-bold
    hover:bg-red-700 focus:outline-offset-2 focus:outline-4 focus:outline-red-400
    active:bg-red-800">
        {{ label }}
    </button>
</template>